let swiperWhyInstance;

function initializeSwiperWhy() {
  swiperWhyInstance = new Swiper(".swiper-why", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    pagination: {
      el: ".why-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".why-next",
      prevEl: ".why-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 41,
      },
    },
  });
}

function destroySwiperWhy() {
  if (swiperWhyInstance) {
    swiperWhyInstance.destroy(true, true);
    swiperWhyInstance = null;
  }
}

function handleResizeWhy() {
  if (window.innerWidth < 768) {
    if (!swiperWhyInstance) {
      initializeSwiperWhy();
    }
  } else {
    if (!swiperWhyInstance) {
      initializeSwiperWhy();
    } else {
      swiperWhyInstance.update();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  handleResizeWhy();
  window.addEventListener("resize", handleResizeWhy);
});
